// LifeChiAI Design Tokens v1.0
// Brand colours confirmed
//   April 24, 2026
// Agency: teal primary (#4CE3CD)
// Gradient: splash + logo only
//   not for general UI components
// TODO: migrate all components
//   as files are touched
// NEVER hardcode hex values in component files — always import from here.

const colors = {

  // ── Brand primaries ───────────────────────
  brandPrimary:        '#4CE3CD',
  brandPrimaryDark:    '#2BB8A4',
  brandPrimaryLight:   '#E0FBF7',
  brandSecondary:      '#7053E2',
  brandSecondaryLight: '#EDE9FC',
  brandBlue:           '#37AFF4',
  brandLavender:       '#D29EFB',
  brandDark:           '#0D0F1F',

  // ── Gradient — splash + logo only ─────────
  gradientStart: '#4CE3CD',
  gradientMid:   '#37AFF4',
  gradientEnd:   '#7053E2',

  // ── Backgrounds ───────────────────────────
  backgroundPage:      '#F8F9F8',
  backgroundCard:      '#FFFFFF',
  backgroundSecondary: '#F5F5F5',

  // ── Text ──────────────────────────────────
  textPrimary:   '#1A1A2E',
  textSecondary: '#555555',
  textMuted:     '#888888',
  textOnBrand:   '#0D0F1F',  // brandDark — 11.92:1 on #4CE3CD (WCAG AAA)
  textLink:      '#4CE3CD',

  // ── Borders ───────────────────────────────
  borderDefault: '#E0E0E0',
  borderStrong:  '#CCCCCC',
  borderBrand:   '#4CE3CD',

  // ── Status — do NOT change with logo ──────
  // These are semantic and must maintain accessibility contrast ratios.
  statusSuccess:      '#27AE60',
  statusSuccessLight: '#EAF7EF',
  statusDanger:       '#E74C3C',
  statusDangerLight:  '#FDEDEC',
  statusWarning:      '#E67E22',
  statusWarningLight: '#FEF5E7',
  statusInfo:         '#2980B9',
  statusInfoLight:    '#EBF5FB',

  // ── UI specific ───────────────────────────
  disabled:     '#CCCCCC',
  disabledText: '#999999',
};

export default colors;
